module.exports = function (a, b, options) {
  if(a == b) // Or === depending on your needs
    return options.fn(this);
  else
    return options.inverse(this);
};